
import React from 'react';
import { connect } from 'react-redux';
import {TextLoading} from "../funcs/utils";
import { Action } from "../funcs/utils";
import {dwollaUpdate, getMXConnect} from "./actions";
import {logUserEvent} from "../app/actions";
import {MX_STATE, MxConnect, update_mx_funding_source} from "./mx-connect";
import {UserEvents} from "../../lib/user-events";

const DEBUG = false;

const launch_iav = (component, url) => () => {
  component.setState({
    mx_flow: MX_STATE.FETCHING_TOKEN,
    iav_error: "",
  });
  const username = component.props.user.username;

  getMXConnect(
    component.props.token, component.props.onboarding_token, url)
    .then(result => {
      console.log("Got", result);
      if (result.status === "OK") {
        component.setState({
          mx_flow: MX_STATE.FLOW,
          url: result.payload.widget_url.url,
        })
      } else if (result.status === "ERROR") {
        console.log("error", result);
        component.setState({
          iav_error: "There was an internal error.",
          mx_flow: MX_STATE.ERROR,
        });
        logUserEvent(__filename, UserEvents.IAV_START, { username }).then();
      }

    })
}

const IAVError = props => {
  const component = props.component;
  const has_error = !!component.state.iav_error;
  const style = {
    color: "red",
    visibility: has_error ? "visible" : "hidden",
    ...props.style,
  }
  return (<span style={style}>{component.state.iav_error}</span>)
}

class IAVFlow_ extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mx_flow: MX_STATE.INIT,
      iav_error: "",
    }
  }

  componentDidMount() {
    window.addEventListener('message', this.onMxMessage);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.onMxMessage);
  }

  onMxMessage = event => {
    const username = this.props.user.username;

    if (event.data && event.data.mx === true) {
      if (DEBUG) {
        console.log("mx event.data", event.data);
      }
      if (event.data.type === 'mx/connect/memberConnected') {
        // Member was added
        this.setState({
          member_guid: event.data.metadata.member_guid,
        })
      } else if (event.data.type === "mx/connect/connected/primaryAction") {
        // MX Connect Widget has completed
        this.setState({
          mx_flow: MX_STATE.ADDING_PAYMENT_SOURCE,
        })
        if (this.props.on_iav_state) {
          this.props.on_iav_state(MX_STATE.ADDING_PAYMENT_SOURCE);
        }
        logUserEvent(__filename, UserEvents.IAV_END, { username }).then();
        update_mx_funding_source(this)
          .then(result => {
            if (result.funding_source_id && result.dwolla) {
              // success
              this.props.dwollaUpdate(result.dwolla, 0);
              this.setState({
                dwolla: result.dwolla,
                mx_flow: MX_STATE.INIT,
              });
              logUserEvent(__filename, UserEvents.IAV_ADDED_PAYMENT_SOURCE, { username }).then();
              if (this.props.on_iav_done) {
                this.props.on_iav_done(result.funding_source_id);
              }
              if (this.props.on_iav_state) {
                this.props.on_iav_state(MX_STATE.INIT);
              }
            } else {
              // Error
              logUserEvent(__filename, UserEvents.IAV_ERROR, {
                username,
                error: result.error,
              }).then();
              this.setState({mx_flow: MX_STATE.ERROR});
              if (this.props.on_iav_state) {
                this.props.on_iav_state(MX_STATE.ERROR);
              }
            }
          });
      }
    }
  }

  on_iav_close = () => {
    this.setState({
      iav_error: "",
      iav_token: "",
      mx_flow: MX_STATE.INIT,
    });
    if (this.props.on_iav_state) {
      this.props.on_iav_state(MX_STATE.INIT);
    }
  }


  launch_iav = url => {
    this.setState({
      mx_flow: MX_STATE.FETCHING_TOKEN,
      iav_error: "",
    });
    if (this.props.on_iav_state) {
      this.props.on_iav_state(MX_STATE.FETCHING_TOKEN);
    }
    const username = this.props.user.username;

    getMXConnect(
      this.props.token, this.props.onboarding_token, url)
      .then(result => {

        if (result.status === "OK") {
          logUserEvent(__filename, UserEvents.IAV_START, { username }).then();
          this.setState({
            mx_flow: MX_STATE.FLOW,
            url: result.payload.widget_url.url,
          })
          if (this.props.on_iav_state) {
            this.props.on_iav_state(MX_STATE.FLOW);
          }
        } else if (result.status === "ERROR") {
          console.log("error", result);
          this.setState({
            iav_error: "There was an internal error.",
            mx_flow: MX_STATE.ERROR,
          });
          if (this.props.on_iav_state) {
            this.props.on_iav_state(MX_STATE.ERROR);
          }
          logUserEvent(__filename, UserEvents.IAV_ERROR, {
            username,
            error: result,
          }).then();
        }

      })
  }

  render = () => {
    const button_text = this.props.button_text;
    const loading = this.state.mx_flow !== MX_STATE.INIT
      && this.state.mx_flow !== MX_STATE.DONE
      && this.state.mx_flow !== MX_STATE.ERROR;
    let status_text = " ";
    if (this.state.mx_flow === MX_STATE.ADDING_PAYMENT_SOURCE) {
      status_text = "Adding Your Bank";
    }
    const status = (
      <div>
        { status_text }
      </div>
    )

    return (
      <div style={{display: "inline"}}>
        { status }
        <Action onClick={() => this.launch_iav(this.props.url)}>
          <TextLoading
            label={ button_text }
            loading={loading}/>
        </Action>
        <MxConnect
          onClose={() => this.on_iav_close()}
          state={this.state}
          component={this}/>

      </div>
    );

  }
}
const init_iav_flow_state = () => {
  return {
    mx_flow: MX_STATE.INIT,
    iav_error: "",
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dwollaUpdate: (data, index) => dispatch(dwollaUpdate(data, index)),
  };
}

const mapStateToProps = state => {
  return {
    token: state.user && state.user.token,
    onboarding_token: state.user && state.user.onboarding_token,
    app: state.app,
    dwolla: state.dwolla,
    user: state.user,
  };
}

const IAVFlow = connect(mapStateToProps, mapDispatchToProps)(IAVFlow_);

export { IAVFlow, IAVError, init_iav_flow_state, launch_iav }
